import styled from 'styled-components';
import { Box, Typography, Button, CircularProgress } from '@mui/material';

export const Description = styled(Typography)`
  && {
    margin-bottom: 24px;
  }
`;

export const FormContainer = styled(Box)`
  && {
    max-width: 400px;
  }
`;

export const ActionsWrapper = styled(Box)`
  && {
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
`;

export const StyledButton = styled(Button)`
  && {
    text-transform: none;
    font-weight: 600;
  }
`;

export const Loader = styled(CircularProgress)`
  && {
    margin-left: 16px;
  }
`;
